import React, { useCallback, useState, useEffect } from 'react';

import Utils from "../../utilities/Utils";
import { useHistory, useParams } from "react-router-dom";
import { showToast } from "../ToastManager";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';

import FinanceiroService from '../../service/FinanceiroService';
import RoleService from '../../service/RoleService';
import AuthorizationService from '../../service/AuthorizationService';

const financeiroService = new FinanceiroService();

const ListarPagamento = () => {
    const [pagamento, setPagamento] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const [totalValorPago, setTotalValorPago] = useState(0);
    const [totalValorStar, setTotalValorStar] = useState(0);
    const [totalValorPrestador, setTotalValorPrestador] = useState(0);
    const history = useHistory();

    const iss = localStorage.getItem('iss');
    let roles = JSON.parse(localStorage.getItem('roles'));

    // Verificar permissões
    const isEmpresaAdmOrAdmin = AuthorizationService.hasPermission('isEmpresaAdm') || RoleService.isAdmin();
    const isAdmin = RoleService.isAdmin();

    const initPagamento = useCallback(async () => {
        const dataInicial = Utils.formatDataAddRemoveDays(null, 365, "-")
        const dataFinal = Utils.formatDataAddRemoveDays(null, 365, "+")
        setLoading1(true);

        try {
            const data = await financeiroService.listAllPagamentos(iss, dataInicial, dataFinal);
            setPagamento(data.data.rows);

            // Calcular totais
            const valorPago = data.data.rows.reduce((sum, item) => sum + (item.valor_pago || 0), 0);
            const valorStar = data.data.rows.reduce((sum, item) => sum + (item.valor_star || 0), 0);
            const valorPrestador = data.data.rows.reduce((sum, item) => sum + (item.valor_prestador || 0), 0);

            setTotalValorPago(valorPago);
            setTotalValorStar(valorStar);
            setTotalValorPrestador(valorPrestador);

        } catch (error) {
            console.error("Erro ao carregar pagamentos:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar pagamentos' });
        } finally {
            setLoading1(false);
        }
    }, [iss]);

    const initFilters1 = () => {
        setFilters1({
            'agendamentos.user.profile.name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'agendamentos.prestadorTipoAgendamento.prestador.nome': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'agendamentos.prestadorTipoAgendamento.tipoAgendamento.nome': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'forma_pagamento': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            'ipag_payments.status': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
        });
    }

    useEffect(() => {
        initFilters1();
        initPagamento();
    }, [initPagamento]);

    const visualizar = (pagamento) => {
        if (roles.getPagamento)
            history.push('/pagamento/visualizar/' + pagamento.id);
    }

    const exportExcel = () => {
        import('xlsx').then(xlsx => {
            const exportData = pagamento.map(item => {
                const baseData = {
                    'Cliente': item.agendamentos?.user?.profile?.name || '-',
                    'Prestador': item.agendamentos?.prestadorTipoAgendamento?.prestador?.nome || '-',
                    'Serviço': item.agendamentos?.prestadorTipoAgendamento?.tipoAgendamento?.nome || '-',
                    'Data Pagamento': Utils.formatData(item.data_pagamento),
                    'Data Agendamento': Utils.formatData(item.agendamentos?.data_agendamento),
                    'Status': item.ipag_payments?.status || '-',
                    'Forma Pagamento': item.forma_pagamento?.toUpperCase() || '-',
                };

                // Adicionar colunas baseadas em permissões
                if (isEmpresaAdmOrAdmin) {
                    baseData['Valor Pago'] = item.valor_pago || 0;
                }

                if (isAdmin) {
                    baseData['Taxa/Comissão'] = item.valor_star || 0;
                }

                baseData['Valor Prestador'] = item.valor_prestador || 0;

                return baseData;
            });

            const worksheet = xlsx.utils.json_to_sheet(exportData);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, 'pagamentos');
        });
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });
                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    }

    // Templates de colunas
    const dataBody = (rowData) => {
        return <span>{Utils.formatData(rowData.data_pagamento)}</span>
    }

    const dataAgendamentoBody = (rowData) => {
        return <span>{Utils.formatData(rowData.agendamentos?.data_agendamento)}</span>
    }

    const statusBody = (rowData) => {
        const status = rowData.ipag_payments?.status?.toUpperCase() || 'DESCONHECIDO';

        let severity = 'info';
        let label = status;

        switch (status) {
            case 'CAPTURED':
                severity = 'success';
                label = 'CAPTURADO';
                break;
            case 'ENVIADO':
                severity = 'warning';
                label = 'ENVIADO';
                break;
            case 'PENDING':
                severity = 'warning';
                label = 'PENDENTE';
                break;
            case 'FAILED':
                severity = 'danger';
                label = 'FALHOU';
                break;
            case 'CANCELED':
                severity = 'danger';
                label = 'CANCELADO';
                break;
            default:
                severity = 'info';
                label = status;
        }

        return <Tag value={label} severity={severity} />;
    }

    const formaPagamentoBody = (rowData) => {
        const forma = rowData.forma_pagamento?.toLowerCase();

        if (forma === 'pix') {
            return (
                <div className="flex align-items-center">
                    <i className="pi pi-qrcode mr-2" style={{ color: '#00B4D8', fontSize: '1.2rem' }}></i>
                    <span>PIX</span>
                </div>
            );
        } else if (forma === 'card') {
            return (
                <div className="flex align-items-center">
                    <i className="pi pi-credit-card mr-2" style={{ color: '#FF6B6B', fontSize: '1.2rem' }}></i>
                    <span>Cartão</span>
                </div>
            );
        }

        return <span>{forma?.toUpperCase() || '-'}</span>;
    }

    const valorPago = (rowData) => {
        const isCaptured = rowData.ipag_payments?.status?.toUpperCase() === 'CAPTURED';
        return (
            <span style={{
                fontWeight: '600',
                color: isCaptured ? '#22C55E' : '#6B7280'
            }}>
                {Utils.formatCurrency(rowData.valor_pago)}
            </span>
        );
    }

    const valorStar = (rowData) => {
        return (
            <span style={{ fontWeight: '600', color: '#3B82F6' }}>
                {Utils.formatCurrency(rowData.valor_star)}
            </span>
        );
    }

    const valorPrestador = (rowData) => {
        return (
            <span style={{ fontWeight: '600' }}>
                {Utils.formatCurrency(rowData.valor_prestador)}
            </span>
        );
    }

    const clienteBody = (rowData) => {
        const nome = rowData.agendamentos?.user?.profile?.name || '-';
        const email = rowData.agendamentos?.user?.email || '';
        const phone = rowData.agendamentos?.user?.profile?.phone || '';

        return (
            <>
                <Tooltip target={`.cliente-${rowData.id}`} />
                <div
                    className={`cliente-${rowData.id}`}
                    data-pr-tooltip={`Email: ${email}\nTelefone: ${phone}`}
                    data-pr-position="top"
                    style={{ cursor: 'pointer' }}
                >
                    <div style={{ fontWeight: '600' }}>{nome}</div>
                    {email && <small className="text-500">{email}</small>}
                </div>
            </>
        );
    }

    const prestadorBody = (rowData) => {
        const nome = rowData.agendamentos?.prestadorTipoAgendamento?.prestador?.nome || '-';
        const email = rowData.agendamentos?.prestadorTipoAgendamento?.prestador?.user?.email || '';

        return (
            <>
                <Tooltip target={`.prestador-${rowData.id}`} />
                <div
                    className={`prestador-${rowData.id}`}
                    data-pr-tooltip={`Email: ${email}`}
                    data-pr-position="top"
                    style={{ cursor: 'pointer' }}
                >
                    <div style={{ fontWeight: '600' }}>{nome}</div>
                    {email && <small className="text-500">{email}</small>}
                </div>
            </>
        );
    }

    const opcoesBody = (rowData) => {
        return (
            <span style={{ display: 'flex', justifyContent: 'space-between' }}>
                {roles.getPagamento ?
                    <Button
                        icon="pi pi-eye"
                        onClick={() => { visualizar(rowData) }}
                        className="p-button-rounded p-button-info mr-2 mb-2"
                        tooltip="Visualizar detalhes"
                        tooltipOptions={{ position: 'top' }}
                    />
                    : null}
            </span>
        );
    }

    // Rodapé dinâmico baseado em permissões
    const getFooterGroup = () => {
        let colspanCount = 5; // Colunas base: Cliente, Prestador, Serviço, Data Pagamento, Data Agendamento, Status, Forma Pagamento

        return (
            <tr>
                <td colSpan={colspanCount} style={{ textAlign: 'right', fontWeight: 'bold' }}>
                    <span>Totais:</span>
                </td>
                {isEmpresaAdmOrAdmin && (
                    <td style={{ fontWeight: 'bold', color: '#22C55E' }}>
                        {Utils.formatCurrency(totalValorPago)}
                    </td>
                )}
                {isAdmin && (
                    <td style={{ fontWeight: 'bold', color: '#3B82F6' }}>
                        {Utils.formatCurrency(totalValorStar)}
                    </td>
                )}
                <td style={{ fontWeight: 'bold' }}>
                    {Utils.formatCurrency(totalValorPrestador)}
                </td>
                <td></td>
            </tr>
        );
    };

    const header = (
        <div className="flex justify-content-between align-items-center">
            <h5 className="m-0">Pagamentos</h5>
            <Button
                type="button"
                icon="pi pi-file-excel"
                onClick={exportExcel}
                className="p-button-success mr-2 mb-2"
                data-pr-tooltip="Exportar Excel"
                tooltip="Exportar para Excel"
                tooltipOptions={{ position: 'top' }}
            />
        </div>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                <div className="card">
                    {header}
                    <DataTable
                        value={pagamento}
                        paginator
                        className="p-datatable-gridlines"
                        showGridlines
                        rows={10}
                        dataKey="id"
                        filters={filters1}
                        filterDisplay="menu"
                        loading={loading1}
                        responsiveLayout="scroll"
                        emptyMessage="Nenhum pagamento realizado."
                        // footerColumnGroup={getFooterGroup()}
                        sortField="data_pagamento"
                        sortOrder={-1}
                    >
                        <Column
                            sortable
                            field="agendamentos.user.profile.name"
                            header="Cliente"
                            body={clienteBody}
                            filter
                            filterPlaceholder="Procurar por cliente"
                            style={{ minWidth: '14rem' }}
                        />
                        <Column
                            sortable
                            field="agendamentos.prestadorTipoAgendamento.prestador.nome"
                            header="Prestador"
                            body={prestadorBody}
                            filter
                            filterPlaceholder="Procurar por prestador"
                            style={{ minWidth: '14rem' }}
                        />
                        <Column
                            sortable
                            field="agendamentos.prestadorTipoAgendamento.tipoAgendamento.nome"
                            header="Serviço"
                            filter
                            filterPlaceholder="Procurar por serviço"
                            style={{ minWidth: '10rem' }}
                        />
                        <Column
                            sortable
                            field="data_pagamento"
                            body={dataBody}
                            header="Data Pagamento"
                            style={{ minWidth: '10rem' }}
                        />
                        <Column
                            sortable
                            field="agendamentos.data_agendamento"
                            body={dataAgendamentoBody}
                            header="Data Agendamento"
                            style={{ minWidth: '10rem' }}
                        />
                        <Column
                            sortable
                            field="ipag_payments.status"
                            body={statusBody}
                            header="Status"
                            filter
                            filterPlaceholder="Filtrar por status"
                            style={{ minWidth: '10rem' }}
                        />
                        <Column
                            sortable
                            field="forma_pagamento"
                            body={formaPagamentoBody}
                            header="Forma Pagamento"
                            filter
                            filterPlaceholder="Filtrar por forma"
                            style={{ minWidth: '10rem' }}
                        />

                        {/* COLUNA CONDICIONAL: Valor Pago - Apenas para EmpresaAdm ou Admin */}
                        {isEmpresaAdmOrAdmin && (
                            <Column
                                sortable
                                field="valor_pago"
                                body={valorPago}
                                header="Valor Pago"
                                style={{ minWidth: '10rem' }}
                            />
                        )}

                        {/* COLUNA CONDICIONAL: Taxa/Comissão - Apenas para Admin */}
                        {isAdmin && (
                            <Column
                                sortable
                                field="valor_star"
                                body={valorStar}
                                header="Taxa/Comissão"
                                style={{ minWidth: '10rem' }}
                            />
                        )}

                        {/* COLUNA: Valor Prestador - Para todos */}
                        <Column
                            sortable
                            field="valor_prestador"
                            body={valorPrestador}
                            header={isEmpresaAdmOrAdmin || isAdmin ? "Valor Prestador" : "Valor Recebido"}
                            style={{ minWidth: '10rem' }}
                        />

                        <Column
                            header="Ações"
                            body={opcoesBody}
                            style={{ width: '8rem' }}
                        />
                    </DataTable>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ListarPagamento, comparisonFn);